import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable ,  Subject } from 'rxjs';
import { AbstractCRUD, CRUDService, ExceptionService, UtilsService } from '../../xform-compat';

/**
 * Data management services provide data related to the system
 */
@Injectable({
  providedIn: 'root'
})
export class DataManagementService extends AbstractCRUD<any> implements CRUDService<any> {
  private categoryAuditUpdate: Subject<any>;
  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(exceptionService, http, utilsService);
    this.categoryAuditUpdate = new Subject<any>();
  }

  /**
   * Sends a message to the subscribed object on the component
   * @param message
   */
  public sendMessageCategoryAuditUpdate(message: string) {
    this.categoryAuditUpdate.next({ text: message });
  }

  /**
   * Observable to listen when a message is sent
   */
  public getMessageCategoryAuditUpdate(): Observable<any> {
    return this.categoryAuditUpdate.asObservable();
  }

  /**
   * @returns {string}
   */
  getResourcePath(): string {
    return '';
  }

  /**
   * Gets data related to category audit logs
   * @param id
   * @param params
   */
  getReferences(id: number, params?: any): Observable<any> {
    const httpParams: HttpParams = params;
    return super.getHTTP().get(`/api/rms/admin/curation/content/references/${id}`,
      { params: httpParams });
  }

  /**
   * create new category
   * @param payload
   */
  postReference(payload: any): Observable<any> {
    return super.getHTTP().post(`/api/rms/admin/curation/content/reference`, payload);
  }

  /**
   * Gets data related to category audit logs
   * @param eventTypes
   * @param params
   */
  getCategoriesAuditLog(eventTypes: string, params?: any): Observable<any> {
    const httpParams: HttpParams = params;
    return super.getHTTP().get(`/api/measures/eventlogs?${eventTypes}`,
      { params: httpParams });
  }

  /**
   * Get listed categories
   * @param pageNumber page number
   * @param pageSize page size
   * @param queryString
   */
  getCategoryList(pageNumber, pageSize, queryString?: string): Observable<any> {
    if ( !queryString ) {
      queryString = '';
    }
    return super.getHTTP().get(`/api/rms/categories?page=${pageNumber}&pagesize=${pageSize}&entityCode=PRODUCT&direction=DESC${queryString}`);
  }

  /**
   * Get listed categories
   * @param queryString
   */
  getCategoryValues(queryString): Observable<any> {
    return super.getHTTP().get(`/api/rms/categoryvalues?&value=${queryString}`);
  }

  /**
   * Get content curation
   * @param pageNumber page number
   * @param pageSize page size
   * @param queryString
   */
  getContentCuration(pageNumber, pageSize, queryString?: string): Observable<any> {
    return super.getHTTP().get(`/api/rms/admin/curation/content?page=${pageNumber}&pagesize=${pageSize}&direction=DESC${queryString}`);
  }

  /**
   * create new category
   * @param categoryName category name
   */
  createCategory(categoryName): Observable<any> {
    return super.getHTTP().post(`/api/rms/categories`, { name: categoryName, code:  'category_code'});
  }

  /**
   * update category value
   * @param categoryId category id
   * @param category category to update
   */
  updateCategoryName(categoryId, category): Observable<any> {
    return super.getHTTP().put(`/api/rms/categories/${categoryId}`, category);
  }

  /**
   *
   * @param value value to update
   */
  updateCategoryValue(value): Observable<any> {
    return super.getHTTP().post(`/api/rms/categoryvalues/onboard`, value);
  }

  /**
   *
   * @param valueId
   */
  deleteCategoryValue(valueId): Observable<any> {
    return super.getHTTP().delete(`/api/rms/categoryvalues/${valueId}`);
  }

  /**
   *
   * @param sourceid
   * @param sourcetype
   */
  curateContent(sourceid, sourcetype): Observable<any> {
    return super.getHTTP().post(`/api/rms/admin/curation/content/${sourceid}/type/${sourcetype}`, null);
  }

  /**
   *
   * @param sourceid
   * @param sourcetype
   */
  revertContentCuration(sourceid, sourcetype): Observable<any> {
    return super.getHTTP().delete(`/api/rms/admin/curation/content/${sourceid}/type/${sourcetype}`);
  }
}
